import { render, staticRenderFns } from "./SlotGiftCard.vue?vue&type=template&id=2e900f78&"
import script from "./SlotGiftCard.vue?vue&type=script&lang=js&"
export * from "./SlotGiftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports